import { useEffect, useState } from "react";
import { Button, Drawer, Form, Input, message, Switch, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import service from "../../api/FetchInterceptor";

const formDataHeaders = {
    ...service.defaults.headers,
    "Content-Type": "multipart/form-data",
};

const AddFormation = ({ id = null, open, setOpen, onSuccess }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [currentCover, setCurrentCover] = useState(null);
    const isEdit = !!id;

    useEffect(() => {
        if (!open) {
            form.resetFields();
            setCurrentCover(null);
            return;
        }

        if (isEdit) {
            service({ method: "GET", url: `admin/formations/${id}` }).then((data) => {
                form.setFieldsValue({
                    title: data.title,
                    subtitle: data.subtitle,
                    description: data.description,
                    is_published: data.is_published,
                });
                setCurrentCover(data.cover_image_url);
            });
        } else {
            form.resetFields();
            form.setFieldsValue({ is_published: false });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, id]);

    const onSubmit = (values) => {
        setLoading(true);

        const payload = {
            title: values.title,
            subtitle: values.subtitle ?? "",
            description: values.description ?? "",
            is_published: values.is_published ? 1 : 0,
        };

        const file = values.cover_image?.[0]?.originFileObj;
        if (file) payload.cover_image = file;
        if (isEdit) payload._method = "PUT";

        service({
            method: "POST",
            url: isEdit ? `admin/formations/${id}` : "admin/formations",
            data: payload,
            headers: formDataHeaders,
        })
            .then((data) => {
                message.success(isEdit ? "Formation mise à jour" : "Formation créée");
                setOpen(false);
                onSuccess?.(data);
            })
            .catch((e) => {
                const errors = e?.response?.data?.errors;
                message.error(errors ? Object.values(errors).flat()[0] : "Erreur lors de l'enregistrement");
            })
            .finally(() => setLoading(false));
    };

    return (
        <Drawer
            title={isEdit ? "Modifier la formation" : "Ajouter une formation"}
            open={open}
            onClose={() => setOpen(false)}
            width={640}
            extra={
                <Button type="primary" loading={loading} onClick={() => form.submit()}>
                    Enregistrer
                </Button>
            }
        >
            <Form form={form} onFinish={onSubmit} layout="vertical">
                <Form.Item name="title" label="Titre" rules={[{ required: true, message: "Le titre est obligatoire" }]}>
                    <Input placeholder="Ex : Pose Gel-X — niveau débutante" />
                </Form.Item>

                <Form.Item name="subtitle" label="Sous-titre">
                    <Input placeholder="Une phrase d'accroche affichée sous le titre" />
                </Form.Item>

                <Form.Item name="description" label="Description">
                    <Input.TextArea rows={6} placeholder="Ce que l'apprenante va apprendre, pour qui, prérequis…" />
                </Form.Item>

                <Form.Item
                    name="cover_image"
                    label="Image de couverture"
                    valuePropName="fileList"
                    getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
                    extra={currentCover ? "Laisser vide pour garder l'image actuelle." : "Format paysage conseillé (16:9), 5 Mo max."}
                >
                    <Upload accept="image/*" listType="picture" maxCount={1} beforeUpload={() => false}>
                        <Button icon={<UploadOutlined />}>Sélectionner une image</Button>
                    </Upload>
                </Form.Item>

                {currentCover && (
                    <img src={currentCover} alt="Couverture actuelle" className="mb-6 max-h-40 rounded-lg object-cover" />
                )}

                <Form.Item
                    name="is_published"
                    label="Publiée"
                    valuePropName="checked"
                    extra="Une formation non publiée n'apparaît pas sur le portail."
                >
                    <Switch />
                </Form.Item>
            </Form>
        </Drawer>
    );
};

export default AddFormation;
